export const mockPartnerRef = [
  { id: 11, partnerId: 1, partnerName: 'ReWire', integrationIdentifier: 'asd123', isIntegrationIdentifierPartnerProvided: true },
  { id: 12, partnerId: 2, partnerName: 'SmartOne', integrationIdentifier: 'bzsds', isIntegrationIdentifierPartnerProvided: true },
  { id: 13, partnerId: 3, partnerName: 'KODE Labs', integrationIdentifier: 'afasf', isIntegrationIdentifierPartnerProvided: true },
  { id: 14, partnerId: 4, partnerName: 'Greystar', integrationIdentifier: '1231AFD', isIntegrationIdentifierPartnerProvided: true },
  { id: 15, partnerId: 5, partnerName: 'Rogers', integrationIdentifier: '1fasdf2', isIntegrationIdentifierPartnerProvided: true },
  { id: 16, partnerId: 6, partnerName: 'Bell', integrationIdentifier: 'fafsa2s', isIntegrationIdentifierPartnerProvided: true },
]

export const mockPartnersRefResponse = {
  data: mockPartnerRef,
  pagination: {
    currentPage: 1,
    perPage: 10,
    totalEntries: mockPartnerRef.length,
  },
}

export const mockAvailablePartnerRef = [
  { id: 17, partnerId: 7, partnerName: 'Telus', integrationIdentifier: 'asd1dd', isIntegrationIdentifierPartnerProvided: true },
  { id: 18, partnerId: 8, partnerName: 'Fido', integrationIdentifier: 'fsdf13', isIntegrationIdentifierPartnerProvided: true },
]
